module.exports = __webpack_public_path__ + "static/media/support40_small_banner.d1fec78d.jpg";